export default __webpack_public_path__ + "static/118-7a6411ca2fb31f3a5025b172296ea4b1.jpg";